'use client';

import { Toaster } from 'sonner';

export default function ToastContainer() {
    return <Toaster visibleToasts={4} position='bottom-left' duration={10000} />;
}
